<template>
  <div>
  <div v-if="!json.init" class="spe-general-goods-one" ref="speGeneralGoodsOne" :style="commonStyle" :ddt-area="`component_${json.floorId}_普通商品一组件`" ddt-expose="on">
    <div class="top" :style="headerStyle">
      <div class="title" :style="{ color: jdata.header ? jdata.header.titleColor || jdata.header.titleDefaultColor : 'initial' }" >{{jdata.header && jdata.header.type == 1 ? jdata.header.title: ''}}</div>
      <div
        class="more"
        :style="{ color: jdata.header ? jdata.header.moreTextColor || jdata.header.moreTextDefaultColor : 'initial' }"
        :data-area="pt()"
        :data-pos="`component_${json.floorId}_普通商品一组件.更多_点击跳转`"
        :data-desc="jdata.header && jdata.header.type == 1 ? jdata.header.moreText : ''"
        :dd_name="`${pt()}.component_${json.floorId}_普通商品一组件.更多_点击跳转.${jdata.header && jdata.header.type == 1 ? jdata.header.moreText : ''}`"
        :ddt-click="`${pt()}.component_${json.floorId}_普通商品一组件.更多_点击跳转.${jdata.header && jdata.header.type == 1 ? jdata.header.moreText : ''}`"
        ddt-pit="更多_点击跳转"
        :ddt-src="jdata.header && jdata.header.type == 1 ? jdata.header.moreText : ''"
        ddt-expose="on"
        @click="$sys.dict.href(jdata.header.jumpContent)"
      >
        {{jdata.header && jdata.header.type == 1 ? jdata.header.moreText:''}}<i v-if="jdata.header && jdata.header.type == 1" class="iconfont">&#xe669;</i>
      </div>
    </div>
    <!-- 样式备注： -->
      <div class="list"  v-if="jdata.products && jdata.products.length > 0" :style="ddStyle">
        <transition-group name="fade">
        <div
          class="item"
          v-for="el in jdata.products"
          :key="el.productId"
          :ddt-src="el.productId"
          :data-comptype="json.compStyle" 
          v-if="el.imgUrl"
          @click="$sys.dict.href(el.link)"
          :data-area="pt()"
          :data-pos="`component_${json.floorId}-普通商品一组件.商品${el.productId}_点击跳转`"
          :data-desc="el.title"
          :dd_name="`${pt()}.component_${json.floorId}_组普通商品一组件.商品${el.productId}_点击跳转.${el.title}`"
          :ddt-click="`${pt()}.component_${json.floorId}_组普通商品一组件.商品${el.productId}_点击跳转.${el.title}`"
          :ddt-pit="`商品${el.productId}_点击跳转`"
          ddt-expose="on"
          :el="el"
        >
          <div class="box">
            <!--<div :style="{'background-image': `url(${el.imgUrl})`}" class="blur" ></div>-->
            <div class="t" :class="{ curve: jdata.priceType == 2 }">
              <div class="img" >
                <img v-lazy="el.imgUrl" alt="" >
              </div>
              <div class="name" v-show="el.title && jdata.priceType != 2">{{ el.title }}</div>
              <div class="btn" :style="buttonStyle" v-if="jdata.buttonInfo.content && jdata.priceType != 2">{{jdata.buttonInfo.content | btn_filter  }}</div>
              <div v-if="jdata.priceType == 2" class="right">
                <div class="curve-name">{{ el.title }}</div>
                <div class="curve-btn">
                  <div class="price"><i>￥</i>{{ getPriceObj(el.salePrice).integer }}<i>{{ getPriceObj(el.salePrice).decimal }}</i></div>
                  <div class="btn-txt">{{jdata.buttonInfo.content | btn_filter  }}</div>
                </div>
              </div>
            </div>
            <div class="b" >
              <div class="desc">{{ el.desc }}</div>
            </div>
          </div>
        </div>
        </transition-group>
      </div>
  </div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import { priceIntegerDecimal } from  '../assets/js/format'
export default {
  name: "spe-general-goods-one",
  props: {
    json: {
      type: Object,
      default: () => {
        return {};
      }
    },
    pagebgcolor: {
      type: String,
      default: 'transparent'
    },
  },
  data(){
    return {
      backgroundUrl: 'http://img3m0.ddimg.cn/16/20/25246600-1_h_2.jpg',
      backgroundUrl1: 'http://img3m1.ddimg.cn/80/1/23778791-1_h_21.jpg'
    }
  },
  inject: ['pt'],
  computed: {
    jdata() {
      return this.json.data || {commonStyle: {}, headerStyle: {}, buttonStyle:{}};
    },
    commonStyle() {
      let sty = {};
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor = this.pagebgcolor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
      return sty;
    },
    headerStyle() {
      let sty = {};
      if (this.jdata.header) {
        if (this.jdata.header.type == 2) {
          sty.backgroundImage = `url(${this.jdata.header.backgroundImage})`;
        } else if(this.jdata.header.type == 1){
          sty.backgroundColor = this.jdata.header.backgroundColor || this.jdata.header.backgroundDefaultColor;
        }
      }
      return sty;
    },
    ddStyle() {
      if(this.jdata.commonStyle.margin > 0){
        let sty = {
          padding: `0 ${this.jdata.commonStyle.margin}px`
        };
        return sty;
      }

    },
    buttonStyle() {
      return {
        backgroundColor : this.jdata.buttonInfo.backgroundColor || this.jdata.buttonInfo.backgroundDefaultColor
      }
    },
  },
  filters: {
      btn_filter(v){
        return v.slice(0,5)
      }
  },
  methods: {
    getPriceObj(price) {
			return priceIntegerDecimal(price)
		},
  }  
}
</script>

<style lang="less" scoped>
  img:not([src]){
    opacity:0;
  }
  .spe-general-goods-one{
    background-color: #fff;
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .top{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: .3rem .2rem;
      box-sizing: border-box;
      background-position: 0 0;
      background-size: 100% 100%;
      .title{
        font-family: PingFangSC-Semibold;
        font-size: .34rem;
        color: #333333;
        line-height: .34rem;
        font-weight: bold;
      }
      .more{
        font-family: PingFangSC-Regular;
        font-size: .26rem;
        color: #666666;
        text-align: right;
        line-height: .26rem;
        font-weight: 400;
      }
    }
    .list{
      padding: .1rem .2rem;
      overflow: hidden;
      .item{
        height: 4.16rem;
        padding-top: .32rem;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: .08rem;
        margin-bottom: .2rem;

        .box{
          width: 100%;
          background-color: #FFF;
          height: 4.0rem;
          position: relative;
          /*border-rradius: .08rem;*/
          border-top-right-radius: .08rem;
          .blur{
            width: 7.1rem;
            height: 4.04rem;
            background-position: center;
            background-size: 150% 100%;
            background-repeat: no-repeat;
            /*-webkit-filter: blur(10px); !* Chrome, Safari, Opera *!*/
            /*filter: blur(10px);*/
            position: absolute;
            top: .1rem;
            left: 50%;
            transform: translate(-50%);
          }
          .t{
            border-top-right-radius: .08rem;
            width: 100%;
            height: 1.7rem;
            background: #fff;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            &::before{
              content:"";
              width: .12rem;
              height: .28rem;
              background: url("//img61.ddimg.cn/upload_img/00860/hjwcms/shadow-1621407004.png") 0 0 no-repeat;
              background-size: 100% 100%;
              position: absolute;
              left: 1.94rem;
              top: 0rem;
            }
            .img{
              background-color: #FFF;
              padding: .04rem;
              border-radius: .08rem;
              overflow: hidden;
              box-sizing: border-box;
              margin-top: -.32rem;
              flex: none;
              > img{
                display: inline-block;
                width: 1.88rem;
                height: 1.88rem;
                border-radius: .08rem;
              }
            }
            .name{
              width: 2.66rem;
              font-family: PingFangSC-Semibold;
              font-size: .34rem;
              color: #333333;
              line-height: .50rem;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .btn{
              width: 1.76rem;
              height: .56rem;
              overflow: hidden;
              background: #F23440;
              border-radius: .28rem;
              font-family: PingFangSC-Medium;
              color: #FFFFFF;
              /*line-height: .26rem;*/
              margin-right: .18rem;
              font-weight: bold;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .right {
              display: flex;
              flex-direction: column;
              margin-left: .18rem;
            
              .curve-name {
                /* width: 4.78rem; */
                font-size: .34rem;
                color: #333333;
                font-weight: bold;
                line-height: .50rem;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              .curve-btn {
                width: 4.2rem;
                height: .92rem;
                background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_price_one-1681442277.png');
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .price {
                  font-size: .38rem;
                  color: #fff;
                  line-height: 0.34rem;
                  font-weight: 600;
                  width: 2.78rem;
                  display: flex;
                  align-items: flex-end;
                  justify-content: center;
                  margin-bottom: 0.04rem;
                  i {
                    font-size: .24rem;
                    color: #fff;
                    line-height: .24rem;
                    font-weight: 600
                  }
                }
                .btn-txt {
                  color: #ff463c;
                  font-weight: 500;
                  font-size: .24rem;
                  font-weight: bold;
                  margin-bottom: 0.04rem;
                  flex: 1;
                }
              }
            }
            &.curve {
              justify-content: flex-start;
            }
          }

          .b{
            width: 100%;
            margin-top: -0.04rem;
            height: 2.18rem;
            /*-webkit-filter: blur(00px); !* Chrome, Safari, Opera *!*/
            /*filter: blur(0px);*/
            background-image: linear-gradient(0deg, #EEEEEE 0%, #FFFFFF 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            padding-bottom: .02rem;
            .desc{
              padding:.06rem .24rem .1rem;
              box-sizing: border-box;
              width: 6.74rem;
              height: 1.86rem;
              background: rgba(255,255,255,0.60);
              border-radius: .08rem;
              text-indent:2em;
              font-family: PingFangSC-Regular;
              font-size: .26rem;
              color: #999999;
              letter-spacing: 0;
              line-height: .44rem;
              font-weight: 400;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              line-clamp: 4;
              -webkit-box-orient: vertical;
            }
            &::before{
              content:"";
              width: .39rem;
              height: .33rem;
              background: url("//img61.ddimg.cn/upload_img/00860/hjw/dot-1622788558.png") 0 0 no-repeat;
              background-size: 100% 100%;
              display: inline-block;
              font-size: .9rem;
              color: #eee;
              position: absolute;
              left: 0.34rem;
              top: 0.14rem;
            }
          }


        }
      }
    }
  }

</style>
